import map from 'lodash/map'
import { AdjustmentStatus } from '@ztechapps/adjustment.common'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

const Statuses = map(AdjustmentStatus, (e) => {
  return e.value
})

export const adjustmentListFieldConfig: ListFieldConfig = {
  code: { name: 'code', displayName: 'Code', index: 0 },

  status: {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: Statuses,
    },
    index: 1,
  },

  createdAt: {
    name: 'createdAt',
    displayName: 'Created date',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.dateTimeZone,
    index: 2,
    size: 150,
  },
  completionDate: {
    name: 'completionDate',
    displayName: 'Completion Date',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.dateTimeZone,
    index: 3,
    size: 150,
  },
  remarks: { name: 'remarks', displayName: 'Remarks', index: 4, size: 400 },
  tags: { name: 'tags', displayName: 'Tags', index: 5, size: 200 },

  _id: { name: '_id', isVisible: false },
}
